import * as React from 'react';
import { AzureDevopsSourceMetadata, SourceType } from '@journeyapps-platform/types-source-service';
import { styled } from '../../../../../theme';
import { System } from '../../../../../System';
import { OrganizationModel } from '@journeyapps-platform/lib-journey-core';
import { AzureProjectDropDownWidget } from './AzureProjectDropDownWidget';
import { IntegrationKind } from '@journeyapps-platform/types-cerberus';
import { AzureReposDropdownWidget } from './AzureReposDropdownWidget';

export type AzureReposPayload = {
  create_repo?: boolean;
  source?: AzureDevopsSourceMetadata;
};

export interface AzureReposSourceControlSubStepWidgetProps {
  name: string;
  payload: AzureReposPayload;
  payloadChanged: (payload: Partial<AzureReposPayload>) => any;
  system: System;
  org: OrganizationModel;
  createIntegration: () => any;
}

export class AzureReposSourceControlSubStepWidget extends React.Component<AzureReposSourceControlSubStepWidgetProps> {
  setProperties = (params: { organization?: string; project?: string; repo?: string; create?: boolean }) => {
    this.props.payloadChanged({
      create_repo: params.create ?? this.props.payload.create_repo,
      source: {
        type: SourceType.AzureDevops,
        properties: {
          organization: (params.organization ?? this.props.payload.source?.properties.organization) || '',
          project: (params.project ?? this.props.payload.source?.properties.project) || '',
          repo: (params.repo ?? this.props.payload.source?.properties.repo) || ''
        }
      }
    });
  };

  render() {
    return (
      <S.Content>
        <AzureProjectDropDownWidget
          org={this.props.org}
          azureProject={this.props.payload.source?.properties?.project}
          azureProjectChanged={(org, project) => {
            this.setProperties({
              organization: org,
              project: project
            });
          }}
          createIntegration={this.props.createIntegration}
        />
        {this.props.payload.source?.properties?.project ? (
          <AzureReposDropdownWidget
            groupingName="project"
            appName={this.props.name}
            repo={this.props.payload.source?.properties?.repo}
            setProperties={this.setProperties}
            org={this.props.org}
            integration={
              this.props.org.integrations.items.find((i) => {
                const properties = i.getProperties<IntegrationKind.AzureDevops>();
                return (
                  properties.project === this.props.payload.source!.properties.project &&
                  properties.organization === this.props.payload.source!.properties.organization
                );
              })!
            }
          />
        ) : null}
      </S.Content>
    );
  }
}

namespace S {
  export const Content = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 416px;
  `;
}
